import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { COLOR_THEME } from '../utils/themer';
import XOSLogoBw from '../images/logo_bw.png';
import { getApiVersionNumber } from '../state/version';
import FilterPane from './FilterPane';

const SidebarContainer = styled.div`
  height: 100%;
  width: ${props => (props.isCollapsed ? '0px' : '270px')};
  background: ${COLOR_THEME.primary};
  display: flex;
  flex-direction: column;
  transition: all 0.2s ease-in-out;
`;

const FilterPaneContainer = styled.div`
  color: ${COLOR_THEME.tertiary};
  flex-grow: 1;
  overflow-y: auto;
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 15px 0 10px 0;

  img {
    max-width: 110px;
    max-height: 25px;
    display: block;
    clear: both;
  }
`;

const DashboardVersion = styled.div`
  color: ${COLOR_THEME.tertiary};
  display: flex;
  justify-content: center;
  padding: 0 0 15px 0;
  font-size: 10px;

  & span {
    font-weight: 600;
  }
`;

class Sidebar extends PureComponent {
  componentDidMount() {
    const { getApiVersionNumber, version } = this.props;
    if (!version) {
      getApiVersionNumber();
    }
  }

  render() {
    const { t, version, isCollapsed } = this.props;

    return (
      <SidebarContainer isCollapsed={isCollapsed}>
        <FilterPaneContainer>
          <FilterPane />
        </FilterPaneContainer>
        <LogoContainer>
          <img id="NavigationBar.LogoBw" src={XOSLogoBw} alt={t('NavigationBar.Logo')} />
        </LogoContainer>
        <DashboardVersion id="Dashboard.Version">
          <span>
            {t('Sidebar.Version')}

            :&nbsp;
          </span>
          {version}
        </DashboardVersion>
      </SidebarContainer>
    );
  }
}

Sidebar.propTypes = {
  isCollapsed: PropTypes.bool.isRequired, // supplied from Redux
  getApiVersionNumber: PropTypes.func.isRequired, // supplied from Redux
  version: PropTypes.string.isRequired, // supplied from Redux
  t: PropTypes.func.isRequired, // supplied from withTranslation
};

const mapStateToProps = state => ({
  isCollapsed: state.sidebar.isCollapsed,
  version: state.version,
});

const mapDispatchToProps = {
  getApiVersionNumber,
};

const TranslatedComponent = withTranslation()(Sidebar);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranslatedComponent);
